module.exports = __webpack_public_path__ + "images/emoji/ledger.77939196e85933efad04.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ledger.png
// module id = zJF3
// module chunks = 14